import loafLogo from '../assets/loaf_app_logo.png';

interface BrandLogoProps {
  className?: string;
  size?: number | string;
  withText?: boolean;
  textColor?: string;
  alt?: string;
}

/**
 * BrandLogo — Official Loaf application logo.
 * Uses the high-resolution brand asset from app/src/main/res/drawable-nodpi/loaf_app_logo.png.
 */
export default function BrandLogo({
  className = 'h-8 w-8',
  size,
  withText = false,
  textColor = 'text-on-surface',
  alt = 'Loaf Logo',
}: BrandLogoProps) {
  const sizeStyle = size ? { width: size, height: size } : undefined;

  return (
    <div className="inline-flex items-center gap-2.5">
      <img
        src={loafLogo}
        alt={alt}
        className={`shrink-0 rounded-xl object-contain shadow-sm ${className}`}
        style={sizeStyle}
      />
      {withText && (
        <span className={`font-display-md text-display-md tracking-tight ${textColor}`}>
          Loaf
        </span>
      )}
    </div>
  );
}
